import { render, staticRenderFns } from "./dragFormVerticalLayout.vue?vue&type=template&id=233da8f4&"
import script from "./dragFormVerticalLayout.vue?vue&type=script&lang=js&"
export * from "./dragFormVerticalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports